var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.741,
    height: 22.514,
    viewBox: "0 0 29.741 22.514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark",
    transform: "translate(-575.223 -303.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M10.835,12.98.149,8.41,10.835,22.092l17.9-20.7Z",
    transform: "translate(575.665 302.759)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.19002db8e24c51c5201de3724028cd82.svg";
export { ForwardRef as ReactComponent };